import { isStringTimeUnit } from '../../../models/data-key';
import { TimeUnitKey } from '../../../types';

const dateTimeUnitsSorter = (a: string, b: string) => new Date(a).getTime() - new Date(b).getTime();
const numberTimeUnitsSorter = (a: string | number, b: string | number) => Number(a) - Number(b);

const getTimeUnitSorter = (
    timeUnitKey: TimeUnitKey
): ((a: number | string, b: number | string) => number) =>
    isStringTimeUnit(timeUnitKey) ? dateTimeUnitsSorter : numberTimeUnitsSorter;

export default getTimeUnitSorter;
